import { http } from "./http";

/**
 * Preview dos projetos gerados.
 * O iframe usa o proxy autorizado do backend: nenhum usuário alcança o
 * container de outro projeto trocando o id na URL.
 */

const BASE_URL = import.meta.env.VITE_API_URL ?? "/api";

export type PreviewStatus = "starting" | "running" | "stopped" | "failed";

export interface PreviewInstance {
  uuid: string;
  status: PreviewStatus;
  url: string | null;
  port: number | null;
  started_at: string | null;
  last_accessed_at: string | null;
  error: string | null;
}

export interface PreviewState {
  enabled: boolean;
  driver: "port" | "traefik";
  embeddable: boolean;
  proxy_path: string;
  preview: PreviewInstance | null;
}

/** URL do iframe (sempre pelo proxy autenticado do Builder). */
export function previewProxyUrl(state: PreviewState): string {
  return `${BASE_URL}${state.proxy_path}`;
}

export const previewService = {
  get: (project: string) => http.get<PreviewState>(`/projects/${project}/preview`),
  start: (project: string) => http.post<PreviewInstance>(`/projects/${project}/preview/start`, {}),
  stop: (project: string) => http.post<PreviewInstance | null>(`/projects/${project}/preview/stop`, {}),
  restart: (project: string) => http.post<PreviewInstance>(`/projects/${project}/preview/restart`, {}),
};
